// Copyright (c) 2016 Deere & Company

import DealerAccountsFacet from '../state/dealer-accounts-facet';
import {getDisplayedDealers} from '../services/facets';
import {updateList} from '../services/list-selections';

export const sharedToggleDealerAccountFacetItems = (state, action) => {

    const updatedSelectedDealers = state.selectedDealers.length ?
        [] :
        action.allowedDealers;

    return DealerAccountsFacet.update(state, {
        selectedDealers: {
            $set: updatedSelectedDealers
        }
    });

};

export const sharedUpdateDealerAccountFacetInput = (state, action) =>
    DealerAccountsFacet.update(state, {
        displayedDealers: {
            $set: getDisplayedDealers(state.allowedDealers, action.value)
        },
        searchInput: {
            $set: action.value
        }
    });

export const sharedUpdateDealerAccountFacetItem = (state, action) =>
    DealerAccountsFacet.update(state, {
        selectedDealers: {
            $set: updateList(
                action.dealerAccount,
                action.isSelected,
                'account',
                state.selectedDealers
            )
        }
    });



// WEBPACK FOOTER //
// ./src/shared/reducers/facets.js